import { useEffect, useState } from 'react';

export default function StickyCtaBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.7);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      data-testid="sticky-cta-bar"
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden transition-transform duration-300"
      style={{
        transform: visible ? 'translateY(0)' : 'translateY(100%)',
        background: 'rgba(0,0,0,0.97)',
        borderTop: '1px solid #1A1A1A',
        boxShadow: '0 -4px 30px rgba(0,255,0,0.08)',
        padding: '12px 16px',
        paddingBottom: 'calc(12px + env(safe-area-inset-bottom))',
      }}
    >
      <div className="flex gap-3 max-w-lg mx-auto">
        <a
          href="tel:9549532937"
          data-testid="sticky-phone-btn"
          className="flex items-center justify-center border border-[#00FF00] text-[#00FF00] transition-colors duration-300 hover:bg-[#00FF00] hover:text-black"
          style={{ width: '48px', height: '48px', flexShrink: 0 }}
          aria-label="Call NexGenPay"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
        </a>
        <button
          onClick={() => document.querySelector('#demo')?.scrollIntoView({ behavior: 'smooth' })}
          data-testid="sticky-demo-btn"
          className="flex-1 btn-neon text-xs flex items-center justify-center gap-2"
          style={{ fontFamily: 'Unbounded, sans-serif', padding: '14px', height: '48px' }}
        >
          Request a Demo
        </button>
      </div>
    </div>
  );
}
